import { TypographyStyles } from '@/styles'
import { Alert, Text } from '@/ui'
import { faClock } from '@fortawesome/pro-solid-svg-icons'
export const NoReportAlert = () => {
  return (
    <div id="bookkeepingReportPanel">
      <Text variant={TypographyStyles.H1} className="mb-4">
        No Bookkeeping Reports...yet!
      </Text>
      <Alert customIconName={faClock} variant="priority">
        Once our team finishes your books from your first month with Heard, you
        will see a monthly report here! Please note: in order for us to
        accurately close your books and release your monthly report each month,
        your monthly bank account statement(s) must be uploaded to your profile
        and all request transactions must be reviewed.
      </Alert>
    </div>
  )
}
